import React, { useState } from 'react';
import Sidebar from './sidebar';
import Header from './header';

function Layout({ children }) {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div className="app-container">
            <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

            {/* Main Content */}
            <div className="main-content-wrapper flex-1 flex flex-col overflow-hidden w-full">
                <Header toggleSidebar={toggleSidebar} />

                {/* Main Content Area */}
                <main className="main-content bg-white p-4 lg:p-8">
                    {children}
                </main>

                {/* Footer */}
                <footer className="footer text-center text-gray-500 text-xs py-4">
                    Read 21 © 2025 - All Rights Reserved
                </footer>
            </div>
        </div>
    );
}

export default Layout;